var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breacrumb',{attrs:{"links":_vm.breadCrumbData}}),_c('h4',{staticClass:"antecedente-content"},[_vm._v("Antecedentes para la Declaración")]),_c('Main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }